// SPDX-License-Identifier: MIT
export type Locale = 'fr' | 'en';
const STORAGE_KEY = 'locale';

export function detectLocale(navLang: string = navigator.language): Locale {
  const stored = getStoredLocale();
  if (stored) return stored;
  return navLang.toLowerCase().startsWith('fr') ? 'fr' : 'en';
}

export function setLocale(locale: Locale): void {
  try {
    localStorage.setItem(STORAGE_KEY, locale);
  } catch { /* private browsing — fallback to in-memory only */ }
}

export function getStoredLocale(): Locale | null {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    return v === 'fr' || v === 'en' ? v : null;
  } catch { return null; }
}
